import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Button from 'common/components/atoms/Button';
import colors from 'common/styles/colors';

const ModalFooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 10px;
  ${props => props.paddingTop && `padding-top: ${props.paddingTop}`};
  ${props => props.showBorderTop && `border-top: 1px solid ${colors.greyXL}`};
`;

function Footer({
  onCancel,
  onSave,
  showCreateTaskTemplate,
  saveDisabled,
  paddingTop,
  showBorderTop,
  showCancel,
  onCreateTaskTemplate,
  showDelete,
  onDelete,
  deleteDisabled,
  deleteLabel
}) {
  const { t } = useTranslation();

  return (
    <ModalFooterContainer paddingTop={paddingTop} showBorderTop={showBorderTop}>
      {showDelete && onDelete && (
        <Button id="footer-delete" cancel onClick={onDelete} disabled={deleteDisabled}>
          {deleteLabel || t('common.delete', { defaultValue: 'Delete' })}
        </Button>
      )}
      {showCancel && (
        <Button id="footer-cancel" cancel onClick={onCancel} margin={showDelete ? '0 0 0 1rem' : undefined}>
          {t('common.cancel')}
        </Button>
      )}
       {showCreateTaskTemplate && (
        <Button id="footer-cancel" margin="0 0 0 1rem" onClick={onCreateTaskTemplate} disabled={saveDisabled}>
          {t('taskDetailsModal.createTemplate')}
        </Button>
       )}
      <Button id="footer-generate-continue" margin="0 0 0 1rem" onClick={onSave} disabled={saveDisabled}>
        {t('common.save')}
      </Button>
    </ModalFooterContainer>
  );
}

Footer.propTypes = {
  showCancel: PropTypes.bool,
  showCreateTaskTemplate: PropTypes.bool,
  showDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  deleteDisabled: PropTypes.bool,
  deleteLabel: PropTypes.string
};

Footer.defaultProps = {
  showCancel: true,
  showCreateTaskTemplate: false,
  showDelete: false,
  onDelete: undefined,
  deleteDisabled: true,
  deleteLabel: undefined
};

export default Footer;
